angular.module('zc.zenclerkS')
  .component('zcLayout', {
    templateUrl: '/templates/zenclerk_s/layout/layout.html',
    controllerAs: 'vm',
    controller: zcLayout,
  });

zcLayout.$inject = ['$translate', 'Devise', 'Environment', 'FeatureNotification', 'ZcsOemService'];
function zcLayout($translate, Devise, Environment, FeatureNotification, ZcsOemService) {
  const vm = this;
  let originalRole, originalAgencyId;

  this.$onInit = () => {
    vm.showMakerepeaterAdminBanner = true;

    Environment.get()
      .then(environment => {
        vm.environment = environment;
      });

    Devise.getCurrentUser()
      .then(currentUser => {
        vm.currentUser = currentUser;
        vm.currentLanguage = $translate.use();
      });

    vm.oemService = ZcsOemService.get();
    vm.setOemService = setOemService;
    vm.resetAllNotifications = resetAllNotifications;
    vm.toggleRole = toggleRole;
    vm.getCurrentRole = getCurrentRole;
    vm.availableLanguage = $translate.getAvailableLanguageKeys();
    vm.setLanguage = setLanguage;
  };

  function resetAllNotifications() {
    FeatureNotification.resetAll()
      .then(() => {
        Devise.currentUser.read_notifications = [];
      });
  }

  function toggleRole() {
    // This only changes the looks on the screen, but might not restrict
    // the user from going to other pages
    if(!originalRole || Devise.currentUser.role === 'master') {
      originalRole = Devise.currentUser.role;
      Devise.currentUser.role = 'common';
    } else {
      Devise.currentUser.role = originalRole;
    }

    if(!_.isUndefined(originalAgencyId)) {
      originalAgencyId = Devise.currentUser.agency_id;
      Devise.currentUser.agency_id = null;
    } else {
      Devise.currentUser.agency_id = originalAgencyId;
    }
  }

  function getCurrentRole() {
    return _.get(Devise.currentUser, 'role', '');
  }

  function setOemService(oemService) {
    ZcsOemService.set(oemService);
    vm.oemService = oemService;
  }

  function setLanguage(lang) {
    $translate.use(lang);
    vm.currentLanguage = lang;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/layout.directive.js